const charms = [
  {
    title: "英語圏でありながら費用が安い",
    body: "アイルランドはイギリスやオーストラリアと比べて生活費・学費が低め。質の高い英語教育をリーズナブルに受けられるのが最大の魅力です。",
    img: "https://public.readdy.ai/ai/img_res/0a09f6496bae3aa86d88d44a66d341cd.jpg",
    icon: "ri-money-euro-circle-line",
  },
  {
    title: "温かいアイルランド人との交流",
    body: "「世界で最も親切な人々」と言われるアイルランド人。留学生に対してもオープンで、自然な英語コミュニケーションを楽しめます。",
    img: "https://readdy.ai/api/search-image?query=friendly%20Irish%20people%20smiling%20students%20international%20classroom%20multicultural%20group%20learning%20English%20language%20school%20bright%20room%20modern%20campus%20Dublin%20Ireland&width=600&height=400&seq=ireland-charm-002&orientation=landscape",
    icon: "ri-emotion-happy-line",
  },
  {
    title: "美しい自然と充実した週末",
    body: "クリフ・オブ・モハーやウィックロー山地など絶景が点在。週末には大自然の中でリフレッシュしながら、充実した留学生活を送れます。",
    img: "https://readdy.ai/api/search-image?query=Cliffs%20of%20Moher%20Ireland%20dramatic%20coastal%20cliffs%20Atlantic%20Ocean%20green%20fields%20stunning%20landscape%20blue%20sky%20majestic%20nature%20tourist%20destination%20emerald%20isle&width=600&height=400&seq=ireland-charm-003&orientation=landscape",
    icon: "ri-landscape-line",
  },
  {
    title: "EUへの玄関口・ヨーロッパ旅行が便利",
    body: "EU加盟国のため、格安LCCでパリ・ロンドン・バルセロナへも簡単アクセス。留学しながらヨーロッパ各地を旅できます。",
    img: "https://readdy.ai/api/search-image?query=Dublin%20airport%20aircraft%20European%20travel%20map%20flags%20diverse%20destinations%20modern%20terminal%20blue%20sky%20travel%20adventure%20international%20flights%20backpacker&width=600&height=400&seq=ireland-charm-004&orientation=landscape",
    icon: "ri-flight-takeoff-line",
  },
];

export default function CharmsSection() {
  return (
    <section id="charms" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Charms</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            🍀 アイルランド留学の魅力 🍀
          </h2>
          <p className="text-gray-500 mt-3 text-sm max-w-xl mx-auto">
            ヨーロッパの中でも特別な英語圏の島国。アイルランドにはほかの国にはない魅力がたくさんあります。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {charms.map((c, i) => (
            <div key={i} className="flex flex-col md:flex-row gap-5 bg-gray-50 rounded-lg overflow-hidden group hover:bg-emerald-50 transition-colors">
              <div className="w-full md:w-48 h-40 flex-shrink-0">
                <img src={c.img} alt={c.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                    <i className={`${c.icon} text-sm`} />
                  </span>
                  <h3 className="font-bold text-gray-800 text-base">{c.title}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{c.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
